<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="870" @cancel="closeModal">
      <a-table :width="800" :columns="columns" :data-source="issueList">
        <span slot="issueTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.issueTitle">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.issueTitle }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="serious" slot-scope="text, record">
          {{ 'P' + record.serious }}
        </span>
        <span slot="isOverTime" slot-scope="text, record">
          <a-tag v-if="record.isOverTime == 1" color="red">{{ '是' }}</a-tag>
          <a-tag v-if="record.isOverTime == 0" color="green">{{ '否' }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
import { taskStatus } from '@/utils/dictionary';
export default {
  props: {
    issueList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      taskStatus,
      columns: [
        {
          title: '缺陷id',
          dataIndex: 'issueId',
          width: '7%',
          key: 'issueId',
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '缺陷标题',
          dataIndex: 'issueTitle',
          width: '25%',
          key: 'issueTitle',
          scopedSlots: { customRender: 'issueTitle' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.projectId && record.issueId ? this.$router.resolve({ name: 'page:project:quality:issue:detail', query: { issueId: record.issueId }, params: { project_id: record.projectId }}).href : '';
      };
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
